<script setup lang="ts">
import Button from "~/components/inputs/Button.vue";
import StickyContainer from "~/components/ui/StickyContainer.vue";
import FormHeader from "~/components/ui/FormHeader.vue";
import LoadingSpinner from "~/components/ui/LoadingSpinner.vue";

defineProps({
  title: { type: String, default: "" },
  submitText: { type: String, default: "CONTINUA" },
  submitDisabled: { type: Boolean, default: false },
  hasSubmit: { type: Boolean, default: true },
  headerClass: { type: String, required: false },
  hasStickyButton: { type: Boolean, default: false },
  hasLoadingSpinner: { type: Boolean, default: false },
  showLoadingSpinner: { type: Boolean, default: false },
  isPaddingX: { type: Boolean, default: true, nullable: true }
});

const emit = defineEmits(["submit"]);

const keyEvent = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    return;
  }
};

const buttonKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    emit('submit', event)
    return;
  }
}

const uid = getCurrentInstance()?.uid;
</script>

<template>
  <div>
    <form
      :id="`form-card-${uid}`"
      :class="isPaddingX ? 'px-4' : ''"
      class="form-card primary py-4 text-gray-700"
      @submit.prevent="emit('submit', $event)"
      @keydown="keyEvent"
    >
    
      <slot name="before-header"></slot>
      
      <FormHeader :header-class="headerClass">{{ title }}</FormHeader>
      <slot name="before"></slot>
      <div
        class="form-body pb-6 flex flex-wrap items-start"
        :class="isPaddingX ? 'sm:px-6 md:px-8' : ''"
      >
        <slot></slot>
      </div>
      <slot name="after"></slot>
      <div v-if="hasSubmit" class="form-footer text-center relative">
        <StickyContainer v-if="hasStickyButton">
          <Button
            :for="`form-card-${uid}`"
            data-testid="formSubmit"
            class="!px-16 whitespace-nowrap"
            type="submit"
            @keydown="buttonKeyDown"
            :disabled="submitDisabled"
          >
            <LoadingSpinner v-if="hasLoadingSpinner && showLoadingSpinner"></LoadingSpinner>
            <template v-else>{{ submitText }}</template>
          </Button>
        </StickyContainer>
        <Button
          v-else
          :for="`form-card-${uid}`"
          data-testid="formSubmit"
          class="!px-16"
          type="submit"
          @keydown="buttonKeyDown"
          :disabled="submitDisabled"
        >
          <LoadingSpinner v-if="hasLoadingSpinner && showLoadingSpinner"></LoadingSpinner>
          <template v-else>{{ submitText }}</template>
        </Button>
        <slot name="link"></slot>
      </div>
    </form>
  </div>
</template>

<style scoped></style>
